import { createClient } from '@supabase/supabase-js';
import { isNativeShell } from './authRedirect';
import { nativeAuthStorage, nativeAuthStorageEnabled } from '../native/nativeSecureStorage';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://rlswsamdudeeqzqloxis.supabase.co';
const SUPABASE_PUBLISHABLE_KEY = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY || 'sb_publishable_g59_s2pEqGnn7cg9btmctQ_q2gEaSNa';
const SUPABASE_PROJECT_REF = (() => {
  try {
    return new URL(SUPABASE_URL).hostname.split('.')[0] || '';
  } catch (_) {
    return '';
  }
})();
const SUPABASE_AUTH_STORAGE_KEY = SUPABASE_PROJECT_REF ? `sb-${SUPABASE_PROJECT_REF}-auth-token` : '';
const NATIVE_AUTH_STORAGE = nativeAuthStorageEnabled() ? nativeAuthStorage : undefined;

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    ...(NATIVE_AUTH_STORAGE ? { storage: NATIVE_AUTH_STORAGE } : {}),
  },
});

function storedAccessToken() {
  if (typeof window === 'undefined' || isNativeShell() || !SUPABASE_AUTH_STORAGE_KEY) return '';
  try {
    const raw = window.localStorage?.getItem(SUPABASE_AUTH_STORAGE_KEY);
    if (!raw) return '';
    const session = JSON.parse(raw);
    const token = String(session?.access_token || session?.currentSession?.access_token || '').trim();
    const expiresAt = Number(session?.expires_at || session?.currentSession?.expires_at || 0);
    if (!token) return '';
    if (expiresAt && expiresAt * 1000 <= Date.now() + 30_000) return '';
    return token;
  } catch (_) {
    return '';
  }
}

function timeoutAfter(ms) {
  return new Promise(resolve => window.setTimeout(() => resolve(''), ms));
}

export async function getMemberAccessToken({ timeoutMs = 4000 } = {}) {
  const persisted = storedAccessToken();
  if (persisted) return persisted;

  try {
    const sessionToken = supabase.auth.getSession()
      .then(({ data }) => String(data?.session?.access_token || '').trim())
      .catch(() => '');
    return await Promise.race([sessionToken, timeoutAfter(Math.max(1000, Number(timeoutMs) || 4000))]);
  } catch (_) {
    return '';
  }
}
